import dayjs from 'dayjs';
var ExpectedDelay = /** @class */ (function () {
    function ExpectedDelay() {
    }
    ExpectedDelay.prototype.toApi = function () {
        var delayedUntilDateTxt = dayjs(this.delayedUntilDate).isValid() ? dayjs(this.delayedUntilDate).toISOString() : null;
        return Object.assign({}, this, {
            delayedUntilDate: delayedUntilDateTxt
        });
    };
    ExpectedDelay.createFromApi = function (dto) {
        if (!dto) {
            return null;
        }
        // make sure to null-check if some fields are optional.
        var delayedUntilDate = dto.delayedUntilDate ? dayjs(dto.delayedUntilDate).toDate() : null;
        return Object.assign(new ExpectedDelay(), dto, {
            delayedUntilDate: delayedUntilDate
        });
    };
    return ExpectedDelay;
}());
export { ExpectedDelay };
